<template>
  <base-content>
    <template v-slot:top>
      <hero-header :heading="`${state} AML & Fraud Checks`" />
    </template>
    <form @submit.prevent>
      <div class="row">
        <div class="col-sm-4">
          <base-field label="Name">
            <base-input v-model="name" placeholder="name" required />
          </base-field>
        </div>
        <div class="col-sm-4">
          <base-field label="Relationship">
            <base-select v-model="relationship" placeholder="relationship" required source="relationships" />
          </base-field>
        </div>
        <div class="col-sm-4">
          <base-field label="Type">
            <base-select v-model="amlType" placeholder="type" required source="amlTypes" />
          </base-field>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-sm-4">
          <base-checkbox v-model="aml.passed">
            AML Passed
          </base-checkbox>
        </div>
        <div class="col-sm-4">
          <base-field addon-left-icon="calendar-alt" label="Date Passed">
            <base-input v-model="aml.datePassed" datepicker placeholder="date passed" />
          </base-field>
        </div>
        <div class="col-sm-4">
          <base-field addon-left-icon="calendar-alt" label="Expires">
            <base-input v-model="aml.expiryDate" datepicker placeholder="expiry date" />
          </base-field>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-sm-4">
          <base-checkbox v-model="pep.passed">
            PEP/Sanctions Passed
          </base-checkbox>
        </div>
        <div class="col-sm-4">
          <base-field addon-left-icon="calendar-alt" label="Date Passed">
            <base-input v-model="pep.datePassed" datepicker placeholder="date passed" />
          </base-field>
        </div>
        <div class="col-sm-4">
          <base-field addon-left-icon="calendar-alt" label="Expires">
            <base-input v-model="pep.expiryDate" datepicker placeholder="expiry date" />
          </base-field>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-sm-4">
          <base-checkbox v-model="fraud.passed">
            Fraud Passed
          </base-checkbox>
        </div>
        <div class="col-sm-4">
          <base-field addon-left-icon="calendar-alt" label="Date Passed">
            <base-input v-model="fraud.datePassed" datepicker placeholder="date passed" />
          </base-field>
        </div>
        <div class="col-sm-4">
          <base-field addon-left-icon="calendar-alt" label="Expires">
            <base-input v-model="fraud.expiryDate" datepicker placeholder="expiry date" />
          </base-field>
        </div>
      </div>
      <supporting-documents class="mt-2" />
      <div class="text-right">
        <base-button icon-right="arrow-right" primary submit>
          Confirm &amp; Save
        </base-button>
      </div>
    </form>
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'
import SupportingDocuments from '@/components/SupportingDocuments.vue'

export default {
  components: {
    HeroHeader,
    SupportingDocuments
  },

  data: () => ({
    action: 'editing',
    name: '',
    relationship: '',
    amlType: '',
    aml: {
      passed: true,
      datePassed: '2018-01-01',
      expiryDate: '2021-01-01'
    },
    pep: {
      passed: false,
      datePassed: '',
      expiryDate: ''
    },
    fraud: {
      passed: false,
      datePassed: '',
      expiryDate: ''
    }
  }),

  mounted () {
    this.action = this.$route.meta.action
  },

  computed: {
    state () {
      switch (this.action) {
        case 'editing':
          return 'Edit'
        case 'creating':
          return 'Create'
      }
    }
  }
}
</script>
